const run = [
    '$rootScope',
    'ProductsFactory',
    'ReleasesFactory',
    'UserFactory',
];

const fn = (
    $rootScope,
    ProductsFactory,
    ReleasesFactory,
    UserFactory
) => {
    ReleasesFactory.fetch();
    ProductsFactory.fetch();
    UserFactory.fetch();
};

run.push(fn);

export default run;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/run.js